import { api } from './api';

function b64urlToBuf(b64url) {
  const pad = '='.repeat((4 - (b64url.length % 4)) % 4);
  const b64 = (b64url + pad).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(b64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr.buffer;
}

function bufToB64url(buf) {
  const bytes = new Uint8Array(buf);
  let s = '';
  for (const b of bytes) s += String.fromCharCode(b);
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export function passkeySupported() {
  return typeof window !== 'undefined' && !!window.PublicKeyCredential && !!navigator.credentials;
}

export async function registerPasskey(name = 'Passkey') {
  const { data: options } = await api.post('/webauthn/register/options');
  options.challenge = b64urlToBuf(options.challenge);
  options.user.id = b64urlToBuf(options.user.id);
  if (options.excludeCredentials) options.excludeCredentials.forEach((c) => { c.id = b64urlToBuf(c.id); });
  const cred = await navigator.credentials.create({ publicKey: options });
  const payload = {
    id: cred.id,
    rawId: bufToB64url(cred.rawId),
    type: cred.type,
    response: {
      attestationObject: bufToB64url(cred.response.attestationObject),
      clientDataJSON: bufToB64url(cred.response.clientDataJSON),
    },
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
  };
  await api.post('/webauthn/register/verify', { credential: payload, name });
}

export async function loginPasskey(email) {
  const { data } = await api.post('/webauthn/login/options', email ? { email } : {});
  const options = data.publicKey;
  options.challenge = b64urlToBuf(options.challenge);
  if (options.allowCredentials) options.allowCredentials.forEach((c) => { c.id = b64urlToBuf(c.id); });
  const assertion = await navigator.credentials.get({ publicKey: options });
  const payload = {
    id: assertion.id,
    rawId: bufToB64url(assertion.rawId),
    type: assertion.type,
    response: {
      authenticatorData: bufToB64url(assertion.response.authenticatorData),
      clientDataJSON: bufToB64url(assertion.response.clientDataJSON),
      signature: bufToB64url(assertion.response.signature),
      userHandle: assertion.response.userHandle ? bufToB64url(assertion.response.userHandle) : null,
    },
    clientExtensionResults: assertion.getClientExtensionResults ? assertion.getClientExtensionResults() : {},
  };
  const res = await api.post('/webauthn/login/verify', { flow_id: data.flow_id, credential: payload });
  return res.data;
}
